import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import { goldGlow } from '../../../shared/glowStyles';
import { RootState } from '../../../store';
import { updateProfileRequest } from '../../../store/auth/authActions';
import { selectIsLogged } from '../../../store/auth/authReducer';
import { selectChatUnreadTotal } from '../../../store/chat/chatReducer';
import { notificationsRequest } from '../../../store/userNotifications/notificationsActions';
import { selectUnreadCount } from '../../../store/userNotifications/notificationsReducer';
import { useDevice } from '../../../utils/hooks/useDevice';
import { useSafeViewport } from '../../../utils/hooks/useSafeViewport';
import { RootStackParamList } from '../../navigator';
import MenuButton from '../../shell/header/MenuButton';
import NotificationButton from '../../shell/header/NotificationButton';
import { HEADER_BAR } from './headerBar';

type Nav = NativeStackNavigationProp<RootStackParamList>;

const Nav = ({ onOpenSidebar: _onOpenSidebar }: { onOpenSidebar: () => void }) => {
	const { navigate } = useNavigation<Nav>();
	const isLogged = useSelector(selectIsLogged);
	const { isDesktop, isMobile } = useDevice();
	const { insets } = useSafeViewport();
	const useCollapsedMobileMenu = isMobile;
	// The buttons share the avatar's bar (HEADER_BAR), so they sit on its centre line on every screen.
	const rightEdgePadding = Math.max(HEADER_BAR.side, insets.right);
	const _iconSize = {
		width: isDesktop ? 45 : 42,
		height: isDesktop ? 45 : 42,
	};

	const unread = useSelector(selectUnreadCount);
	const chatUnread = useSelector(selectChatUnreadTotal);
	const user = useSelector((state: RootState) => state.auth.user);
	const dispatch = useDispatch();

	const [sound, setSound] = useState(true);

	useEffect(() => {
		if (user) {
			setSound(Boolean(user.isSoundEffectsEnabled));
		}
	}, [user]);
	const _handleSoundClick = () => {
		const next = !sound;

		setSound(next);

		dispatch(
			updateProfileRequest({
				isSoundEffectsEnabled: next,
			}),
		);
	};

	useEffect(() => {
		dispatch(notificationsRequest());
	}, [dispatch]);

	const closeMenu = () => {};

	const navButtons = (
		<>
			{/* <TouchableOpacity
				style={iconSize}
				sound={false}
				onPress={() => {
					playSound('ButtonPressed', { force: true });
					handleSoundClick();
					closeMenu();
				}}
				{...testProps('cta-nav-sound')}
			>
				<Image source={sound ? SoundOn : SoundOff} style={[iconSize, styles.iconGlow]} />
			</TouchableOpacity> */}
			{/* <TouchableOpacity
				style={iconSize}
				onPressIn={() => preloadGroup('buyChips')}
				onPress={() => {
					navigate('BuyPackages', { activeTab: 'chips' });
					closeMenu();
				}}
				{...testProps('cta-nav-buy-chips')}
			>
				<Image source={BtnNavChipPng} style={[iconSize, styles.iconGlow]} />
			</TouchableOpacity> */}

			{/* Logged out, the design's top bar is just LOG IN and the settings button (5911:55875). */}
			{isLogged ? (
				<NotificationButton
					unread={unread}
					dot={chatUnread > 0}
					onPress={() => {
						navigate('Messages');
						closeMenu();
					}}
				/>
			) : null}

			{/* Figma's top bar calls this the "Settings Button": it opens the settings popup
			    (5054:78824), which replaced the side menu. */}
			<MenuButton
				onPress={() => {
					navigate('Settings');
					closeMenu();
				}}
			/>
		</>
	);

	if (useCollapsedMobileMenu) {
		return (
			<View pointerEvents='box-none' style={styles.mobileMenuOverlay}>
				<View
					pointerEvents='box-none'
					style={[
						styles.mobileMenuWrap,
						styles.mobileButtonsRow,
						{ paddingRight: rightEdgePadding },
					]}
				>
					{navButtons}
				</View>
			</View>
		);
	}

	return (
		<>
			<View style={styles.rightRail}>
				<View
					style={[styles.icons, { gap: isDesktop ? 10 : 2 }, { paddingRight: rightEdgePadding }]}
				>
					{navButtons}
				</View>
			</View>
		</>
	);
};

export default Nav;

const styles = StyleSheet.create({
	icons: {
		height: HEADER_BAR.top + HEADER_BAR.height,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		paddingTop: HEADER_BAR.top,
		paddingRight: HEADER_BAR.side,
	},
	mobileMenuOverlay: {
		position: 'absolute',
		top: 0,
		right: 0,
		left: 0,
		zIndex: 1000,
	},
	mobileMenuWrap: {
		width: '100%',
		height: HEADER_BAR.top + HEADER_BAR.height,
		alignItems: 'flex-end',
		paddingTop: HEADER_BAR.top,
		paddingRight: HEADER_BAR.side,
	},
	mobileButtonsRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		// Figma "Actions": the settings button starts 54 after the notification one, both 44 wide.
		gap: 10,
	},
	icon: {
		width: 45,
		height: 45,
	},
	iconGlow: {
		...goldGlow,
	},
	rightRail: {
		alignItems: 'flex-end',
	},
});
